module.exports = __webpack_public_path__ + "img/YR25-0500-2-complete.0017ac51.png";